import * as React from 'react';
import { compose } from 'recompose';
import { scaleLinear } from 'd3-scale';
import { max as d3Max, min as d3Min } from 'd3-array';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { ValueMappers } from 'shared/components/Chart/types';
import InnerShadowFilter from 'shared/components/Chart/components/InnerShadowFilter';
import Bars from 'shared/components/Chart/components/Bars';
import Plot from 'shared/components/Chart/components/Plot';
import { BarChartFragment_data as Point } from './__generated__/BarChartFragment';

import './index.scss';

const values: ValueMappers<any, number> = {
  x: (_, i?: number) => i || 0,
  y: (d: Point) => d.value,
};

interface Bar {
  value: number;
  title?: string;
}

export type BarChartData = Bar[];

interface Props {
  data: Point[];
  width: number;
  height?: number;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

class IdeaBarChart extends React.Component<Enhanced> {
  render() {
    const { t, data } = this.props;
    const width = this.props.width || 912;
    const height = this.props.height || 200;

    const plotGeo = {
      left: 0,
      top: 0,
      width,
      height,
    };

    const xScale = scaleLinear()
      .rangeRound([0, plotGeo.width - 1])
      .domain([-0.5, (d3Max<any, number>(data, values.x) || 0) + 0.5]);

    const absMax = Math.max(
      d3Max<any, number>(data, values.y) || 0,
      -(d3Min<any, number>(data, values.y) || 0)
    );

    const yScale = scaleLinear()
      .rangeRound([plotGeo.height - 2, 0])
      .domain([-absMax, absMax]);

    return (
      <svg className="chart" width={width} height={height}>
        <defs>
          <InnerShadowFilter />
        </defs>
        <Plot className="idea-bar-chart" geo={plotGeo}>
          <Bars
            data={data}
            scales={{ x: xScale, y: yScale }}
            values={values}
            formatValue={(d: Bar) => t(d.title) || `${d.value}` || ''}
          />
        </Plot>
      </svg>
    );
  }
}

export default enhance(IdeaBarChart);
